import { Wrapper } from './HamburgerButton.parts';
import type { HamburgerButtonProps } from './HamburgerButton.types';

export function HamburgerButton(props: HamburgerButtonProps) {
	return (
		<Wrapper {...props}>
			<div />
			<div />
			<div />
		</Wrapper>
	);
}
